export default {
    steps: {
      applicant: {
        valid: false,
        data: {
          first_name: "",
          middle_name: "",
          last_name: "",
          dob: "",
          occupation: "",
          gender: "",
          married: "",
          sr_22: "",
          address: "",
          apt: "",
          city: "",
          state: "",
          county: "",
          zipcode: "",
          email: "",
          phone: "",
          term: 6,
          contract_start_date: "",
          rent_own: "OWNED",
          is_other_insurance: false,
          employer_zipcode: null,
          is_employer_zipcode: false,
          other_insurance: {
            company: "OTHER",
            terms: "",
          },
        },
      },
      vehicles: {
        valid: false,
        car: {
          car_vin: "",
          car_make: "",
          car_model: "",
          car_year: "",
          car_lease: "",
          use_type: "",
          coverages: {
            BI: "25000-50000",
            UM: "25000-50000",
            PD: "20000",
            MEDPM: "1000",
          },
        },
        coveredges_plan: "minimum",

        data: [],
      },

      drivers: {
        driver_count: "",
        driver: {
          first_name: "",
          middle_name: "",
          last_name: "",
          dob: "",
          occupation: "",
          gender: "",
          married: "",
          sr_22: "",
          // auto_dvantage: "on",
          any_tickets: false,
          relation_with_holder: "",
          dl_state: null,
          dl_number: null,
          dl_exp: null,
          license_status: null,
          tickets: [],
        },
        data: [],
      },
      quote: {
        details: null,
        socket_id: null,
        isCompare: false,
        checkAmount: false,
        updateQuoteLoader: false,
        finalPageLoader: false,
        isSelectPlan: false,
        isQuestionRequest: false,
        payment_data: {
          basic: null,
          recommend: null,
        },
        basic: {
          response: null,
          payment_info: null,
          stripe_intent: null,
        },
        addons_amount: null,
        total_premium: "232",
        response: null,
        phone: "",
        isVerify: false,
        eSign: false,
        docuSign: {
          esign_url: "",
        },
        plan: null,
        payment_info: null,
        stripe_intent: null,
        payment_plan: "monthly",
        answers: {
          answered: false,
          data: [],
        },
        getQuoteError: null,
        type: "basic",
        custom: false,
      },
      contract: {},
      final: {},
      // buy: {},
      contract_payment: [],
      payment: {},
    },
    providers: [],
    tmp_addons: [],
    quoteAddons: {
      cars: [],
      drivers: [],
    },
    addons: [],
    addonsList: [],
    isAuth: false,
    currentStep: "applicant",
    carsMake: [],
    carsModel: [],
    occupations: [],
    states: [],
    zipcode: "",
    timeStamp: "",
    dataLayer: [],
    isChooseContract: false,
    socketLoadingStatus: true,
    is_impersonating: false,
    docuSignIsCompleted: false,
    alert_fee_message: null,
    newsletter: true,
    fullCoverages: false
  }